<div class="validation-detail-container">
  <div class="validation-header">
    <div class="header-content">
      <div class="header-info">
        <p>
          Last validation check: 
          <strong>{{ location.extras.last_validation_check | date : "dd LLLL yyyy HH:mm" }}</strong>
                  - Is Candidate: 
          <i class="fa" 
             [ngClass]="location.extras.is_candidate ? 'fa-check-square text-success' : 'fa-times text-danger'"
             aria-hidden="true"></i>
        </p>
      </div>
      
      <div class="header-actions">
        <button
          *ngIf="location.extras.validation_state === validationStatuses.VARIATION_FOUND"
          (click)="approveSuggestion()"
          class="btn btn-success">
        APPROVE
        </button>
        <button
          *ngIf="location.extras.validation_state === validationStatuses.VARIATION_FOUND"
          (click)="rejectSuggestion()"
          class="btn btn-danger">
        REJECT
        </button>
        <button
          *ngIf="location.extras.validation_state !== validationStatuses.VARIATION_FOUND"
          [disabled]="!location.address.geo_decimal.lng || !location.address.geo_decimal.lat"
          (click)="validateAddress()"
          class="btn btn-validate">
      VALIDATE
        </button>
      </div>
    </div>
  </div>

  <div class="similar-addresses-section" *ngIf="location.extras.is_candidate && similarAddresses.length > 0">
    <div class="similar-addresses-box">
      <h6 class="section-title">
        Similar Validated Addresses
      </h6>
      <p class="section-description">These addresses with the same street name are already validated and in use:</p>
      
      <div *ngIf="loadingSimilarAddresses" class="text-center">
        <i class="fa fa-spinner fa-spin"></i> Loading...
      </div>
      
      <div *ngIf="!loadingSimilarAddresses && similarAddresses.length > 0" class="similar-addresses-list">
        <div *ngFor="let addr of similarAddresses" class="similar-address-item">
          <strong class="address-street">{{ addr.address.street }} {{ addr.address.house_no }}</strong>
          <div class="address-city">{{ addr.address.zip }} {{ addr.address.city }}</div>
          <div class="address-meta">
            <span>Usage Count: {{ addr.extras.usage_count }}</span>
            <span class="last-used">Last used: {{ addr.extras.last_used | date : "dd MMM" }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="content-wrapper">
    <div class="map-section">
      <div *ngIf="!isMapLoaded" class="map-placeholder" (click)="loadMap()" style="height: 400px; display: flex; align-items: center; justify-content: center; background: #e9ecef; cursor: pointer; border: 2px dashed #6c757d; border-radius: 4px;">
        <div style="text-align: center;">
          <i class="fa fa-map" style="font-size: 48px; color: #6c757d; margin-bottom: 10px;"></i>
          <p style="color: #6c757d; font-size: 16px; margin: 0;">Click to load map</p>
        </div>
      </div>
      <google-map
        *ngIf="isMapLoaded"
        [height]="'400px'"
        [width]="'100%'"
        [center]="mapCenter"
        [zoom]="mapZoom"
        [options]="mapOptions">
        
        <!-- Current Location Marker -->
        <map-marker
          *ngIf="currentMarkerPosition"
          [position]="currentMarkerPosition"
          [options]="currentMarkerOptions"
          [title]="'Current Location'"
          #currentMarker="mapMarker">
        </map-marker>
        <map-info-window>
          <div style="padding: 8px; min-width: 200px;">
            <strong style="color: #4285F4; font-size: 14px;">Current Location</strong><br>
            <div style="margin-top: 5px; font-size: 12px;">
              <strong>Address:</strong> {{ location.address?.street }} {{ location.address?.house_no }}<br>
              <strong>City:</strong> {{ location.address?.zip }} {{ location.address?.city }}<br>
              <strong>Country:</strong> {{ location.address?.country?.code }}<br>
              <strong>Coordinates:</strong><br>
              Lat: {{ location.address?.geo_decimal?.lat }}<br>
              Lng: {{ location.address?.geo_decimal?.lng }}
            </div>
          </div>
        </map-info-window>

        <map-marker
          *ngIf="suggestedMarkerPosition"
          [position]="suggestedMarkerPosition"
          [options]="suggestedMarkerOptions"
          [title]="'Suggested Location'"
          #suggestedMarker="mapMarker">
        </map-marker>
        <map-info-window *ngIf="suggestedData">
          <div style="padding: 8px; min-width: 200px;">
            <strong style="color: #34A853; font-size: 14px;">Suggested Location</strong><br>
            <div style="margin-top: 5px; font-size: 12px;">
              <strong>Address:</strong> {{ suggestedData.street_name }} {{ suggestedData.number }}<br>
              <strong>City:</strong> {{ suggestedData.zip }} {{ suggestedData.city_name }}<br>
              <strong>Country:</strong> {{ suggestedData.country_code }}<br>
              <strong>Coordinates:</strong><br>
              Lat: {{ suggestedData.lat_lon?.lat }}<br>
              Lng: {{ suggestedData.lat_lon?.lng }}
            </div>
          </div>
        </map-info-window>

        <!-- Line between markers -->
        <map-polyline
          *ngIf="polylinePath.length > 0"
          [path]="polylinePath"
          [options]="polylineOptions">
        </map-polyline>
      </google-map>
      
    </div>

    <div class="comparison-section">
      <h6 class="section-title">Change suggestions</h6>
      <table class="table table-sm comparison-table">
        <thead>
          <tr>
            <th width="30%">Field</th>
            <th width="35%">Current Data (C)</th>
            <th width="35%">Suggested Data (S)</th>
          </tr>
        </thead>
        <tbody>
  
          <ng-container *ngIf="!suggestedData && location.extras.validation_state === validationStatuses.NOT_FOUND">
            <tr>
              <td colspan="3" class="text-center text-warning">
                <i class="fa fa-exclamation-triangle"></i> 
                Suggested data not found - address validation returned no results
              </td>
            </tr>
          </ng-container>
          
          <ng-container *ngIf="!suggestedData && !location.extras.validation_state">
            <tr>
              <td colspan="3" class="text-center text-muted">
                <i class="fa fa-spinner fa-spin"></i> 
                Loading suggested data...
              </td>
            </tr>
          </ng-container>
          

          <ng-container *ngIf="suggestedData">
            <tr [class.row-different]="isDifferent(location.address.street, suggestedData.street_name)">
              <td><strong>Street</strong></td>
              <td>{{ location.address.street }}</td>
              <td [class.cell-highlighted]="isDifferent(location.address.street, suggestedData.street_name)">
                {{ suggestedData.street_name || '—' }}
              </td>
            </tr>
            <tr [class.row-different]="isDifferent(location.address.house_no, suggestedData.number)">
              <td><strong>Number</strong></td>
              <td>{{ location.address.house_no }}</td>
              <td [class.cell-highlighted]="isDifferent(location.address.house_no, suggestedData.number)">
                {{ suggestedData.number || '—' }}
              </td>
            </tr>
            <tr [class.row-different]="isDifferent(location.address.zip, suggestedData.zip)">
              <td><strong>ZIP</strong></td>
              <td>{{ location.address.zip }}</td>
              <td [class.cell-highlighted]="isDifferent(location.address.zip, suggestedData.zip)">
                {{ suggestedData.zip || '—' }}
              </td>
            </tr>
            <tr [class.row-different]="isDifferent(location.address.city, suggestedData.city_name)">
              <td><strong>City</strong></td>
              <td>{{ location.address.city }}</td>
              <td [class.cell-highlighted]="isDifferent(location.address.city, suggestedData.city_name)">
                {{ suggestedData.city_name || '—' }}
              </td>
            </tr>
            <tr [class.row-different]="isDifferent(location.address.country.code, suggestedData.country_code)">
              <td><strong>Country</strong></td>
              <td>{{ location.address.country.code }}</td>
              <td [class.cell-highlighted]="isDifferent(location.address.country.code, suggestedData.country_code)">
                {{ suggestedData.country_code || '—' }}
              </td>
            </tr>
            <tr *ngIf="suggestedData.lat_lon" [class.row-different]="isDifferent(location.address.geo_decimal.lng, suggestedData.lat_lon.lng)">
              <td><strong>Longitude</strong></td>
              <td>{{ location.address.geo_decimal.lng }}</td>
              <td [class.cell-highlighted]="isDifferent(location.address.geo_decimal.lng, suggestedData.lat_lon.lng)">
                {{ suggestedData.lat_lon.lng }}
              </td>
            </tr>
            <tr *ngIf="suggestedData.lat_lon" [class.row-different]="isDifferent(location.address.geo_decimal.lat, suggestedData.lat_lon.lat)">
              <td><strong>Latitude</strong></td>
              <td>{{ location.address.geo_decimal.lat }}</td>
              <td [class.cell-highlighted]="isDifferent(location.address.geo_decimal.lat, suggestedData.lat_lon.lat)">
                {{ suggestedData.lat_lon.lat }}
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
